import { environment } from 'src/environments/environment';

export class ApiConstants {
    static readonly URL = environment.api.url;
}
